export default class ContractObj {
    totalValue
    startOperation
    readjustmentDate
    paymentInstrument
    paymentConditionCode
    minimumBilling
    justification
    contractStart
    contractRootNumber
    contractNumber
    transhipment
    contractItem
    contractId
    contractEnd
    contractBirth
    companyId
    collectionPoint
    clientDocument
    blockIfOverdue
    alterationDate
    additiveNumber

    constructor () {
      this.contractItem = []
      this.collectionPoint = []
    }
}
